import React from 'react';
import { Col } from '../../components/GridSystem';

const PortfolioItem = ({data, index}) => {
    const lg = index === 0 ? 8 : 4;

    return (
        <Col xs={12} md={6} lg={lg} className="portfolio-item">
            <span className="portfolio-item__link">
                <span 
                    className="portfolio-item__inner layer-cover layer-cover-bg"
                    style={{ backgroundImage: `url('${data.image}')` }}
                />
            </span>
        </Col>
    );
};

export default PortfolioItem;



// WEBPACK FOOTER //
// ./src/components/PortfolioItem/index.js